import React from 'react';
import { numberOrZero } from '../helpers/numberOrZero';

export const PercentText = ({ unit = 1, ...rest }) => {
    const roundedPercent = Math.round(numberOrZero(unit) * 100);
    const percentText = unit > 0 && roundedPercent === 0 ? '<1%' : `${roundedPercent}%`;
    return <div {...rest}>{percentText}</div>;
};
